import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import StyledMenuItem from 'components/StyledMenuItem';
import StyledMenu from 'components/StyledMenu';
import { linkStyle } from './Link';
import { useRouter } from 'next/router';

const useStyles = makeStyles(theme => ({
  root: {},
  menuContainer: {
    ...linkStyle,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 2,
    cursor: 'pointer',
  },
}));

const DropDownMenu = ({ title, pages }) => {
  const classes = useStyles();
  const router = useRouter();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <div onClick={handleClick} className={classes.menuContainer}>
        {title}
      </div>
      <StyledMenu
        disableScrollLock={true}
        id={`${title.toLowerCase()}-menu`}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}>
        {pages.map(({ title, link }, index) => (
          <StyledMenuItem
            style={{
              fontSize: 12,
              fontWeight: 500,
              letterSpacing: 1.12,
              textDecoration: 'none',
              textTransform: 'uppercase',
            }}
            key={index}
            onClick={() => {
              handleClose();
              router.push(link);
            }}>
            {title}
          </StyledMenuItem>
        ))}
      </StyledMenu>
    </>
  );
};

DropDownMenu.propTypes = {
  title: PropTypes.string.isRequired,
  pages: PropTypes.array.isRequired,
};

DropDownMenu.defaultProps = {};

export default DropDownMenu;
